/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_Th2Inputs */

const en_mk_cmp_notion_th2 = /** @type {(inputs: Mk_Cmp_Notion_Th2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents are triggered by schedules or changes; they are not assignees.`)
};

const id_mk_cmp_notion_th2 = /** @type {(inputs: Mk_Cmp_Notion_Th2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen dipicu jadwal atau perubahan; bukan penanggung jawab pekerjaan.`)
};

/**
* | output |
* | --- |
* | "Agents are triggered by schedules or changes; they are not assignees." |
*
* @param {Mk_Cmp_Notion_Th2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_th2 = /** @type {((inputs?: Mk_Cmp_Notion_Th2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_Th2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_th2(inputs)
	return en_mk_cmp_notion_th2(inputs)
});